import Model from '@/models/Model.js';

export default class RubricCriteria extends Model {
    static entity = 'rubric_criterias';

    static modelName = 'RubricCriteria';

    static fields() {
        return {
            id: this.attr(null),
            rubric_id: this.attr(null),
            title: this.attr(null),
            description: this.attr(null),
            max_value: this.attr(null),
            order: this.attr(null),

            ...super.fields(),

            rubric: this.belongsTo('rubrics', 'rubric_id'),
            criteria_ratings: this.hasMany('rubric_criteria_ratings', 'rubric_criteria_id'),
        };
    }
}
